import React, { useEffect, useState, useMemo } from 'react'
import Sidedash from '../uicomponents/Sidedash'
import { formatDate, convertToIST } from '../utils/Utilsfunc';
import { getPaginationItems } from '../../utils/paginationRange';

const ActivityLog = () => {
    const host = process.env.REACT_APP_BACKEND_URL;
    const [logData, setLogData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 50;
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${host}/activity/getlog?page=${currentPage}&limit=${limit}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': localStorage.getItem('token'),
                    }
                })
                const data = await response.json();
                setLogData(data.activity || []);
                setTotalCount(data.totalCount || 0);
            } catch (error) {
                setLogData([]);
                setTotalCount(0);
            }
        };
        fetchData();
    }, [currentPage, host]);

    function auditValuesEqual(lhs, rhs) {
        if (lhs === rhs) return true;
        if (lhs == null && rhs == null) return true;
        const isDateLike = (value) =>
            value instanceof Date || (typeof value === 'string' && !Number.isNaN(Date.parse(value)));
        if (isDateLike(lhs) || isDateLike(rhs)) {
            try {
                return formatDate(lhs) === formatDate(rhs);
            } catch {
                return false;
            }
        }
        return false;
    }

    function humanReadableAuditLog(change, collectionName, affactedDoc, operationType) {
        //console.log(`Operation Type: ${operationType}, Collection Name: ${collectionName}`);
        //console.log(operationType)
        if (!change.path || !collectionName) {
            return null; // Handle missing data gracefully
        }

        const pathParts = change.path.slice(1); // Skip leading empty element
        const changedField = pathParts.join('.');
        const changeFieldStudents = change.path[0]
        // console.log(changedField, "ChangeField")
        // console.log(pathParts, "Pathparts")
        //console.log(change.path[2], 'hellohi why')
        let message = '';

        switch (collectionName) {

            case 'seats':
                //const seatNumber = change.originalSeatNumber;
                const period = change.path[1]; // Assuming night is the second element
                //console.log(period, "hello period")
                message = `Seat number ${affactedDoc} - `;

                switch (change.kind) {
                    case 'E': // Edit
                        if (auditValuesEqual(change.lhs, change.rhs)) {
                            return null; // No actual change, skip logging
                        }

                        if (changedField.includes('status')) {
                            message += `${period} slot ${change.lhs ? 'became available' : 'was booked'}.`;
                        } else if (changedField.includes('bookedBy')) {
                            if (change.lhs) {
                                message += `student ${change.lhs} has been removed from ${period} slot.`;
                            } else {
                                message += `${period} slot has been assigned to the user "${change.rhs}".`;
                            }
                        } else if (changedField.includes('seatValidTill')) {
                            if (change.lhs !== null && change.rhs === null) {
                                message += `${period} slot validity ${change.lhs ? formatDate(change.lhs) : change.lhs} has been removed.`;
                            } else if (change.lhs === null && change.rhs !== null) {
                                message += `${period} slot validity has been assigned to ${change.rhs ? formatDate(change.rhs) : change.rhs}.`;
                            } else if (change.lhs !== null && change.rhs !== null) {
                                message += `${period} slot validity has been updated from ${change.lhs ? formatDate(change.lhs) : change.lhs} to ${change.rhs ? formatDate(change.rhs) : change.rhs}.`; // Human-readable date format
                            }
                        } else {
                            // Handle other potential changes within seatStatus
                            message += `${changedField} changed from "${change.lhs}" to "${change.rhs}".`;
                        }
                        break;
                    case 'N': // New (not applicable for seatStatus edits)
                        break;
                    case 'D': // Delete (not applicable for seatStatus edits)
                        break;
                    default:
                        console.warn(`Unknown change kind: ${change.kind}`); // Log a warning for unexpected kinds
                }
                break;
            case 'students':

                const studentId = affactedDoc || 'Unknown Student'; // Handle missing originalStudentId

                switch (operationType) {
                    case 'PATCH':
                        if (change.kind === 'E') {
                            message = `Student ${studentId} - ${changeFieldStudents} changed from "${change.lhs}" to "${change.rhs}".`;
                        } else {
                            console.warn(`Unknown change kind: ${change.kind} for students`);
                        }
                        break;

                    case 'DELETE':
                        message = `Student ${affactedDoc} has been deleted.`;
                        break;
                    default:
                        console.warn(`Unknown change kind: ${change.kind} for students`);
                }
                break;

            case 'bookings':
                switch (operationType) {
                    case 'PATCH':
                        if (change.kind === 'E') {
                            message = `Booking ${affactedDoc} - ${changeFieldStudents} changed from "${change.lhs}" to "${change.rhs}".`;
                        } else {
                            console.warn(`Unknown change kind: ${change.kind} for bookings`);
                        }
                        break;

                    case 'DELETE':
                        message = `Booking ${affactedDoc} has been deleted.`;
                        break;
                    case 'POST': 
                    
                        message = `New Booking entry with receipt number ${affactedDoc} created.`;
                        break;
                    default:
                        console.warn(`Unknown operation type: ${operationType} for bookings`);
                }
                break;

            default:
                console.warn(`Unsupported collection: ${collectionName}`);
        }



        return message.trim() ? <li key={change.path}>{message}</li> : null;
    }

    // Pagination controls
    const totalPages = Math.ceil(totalCount / limit);
    const paginationItems = useMemo(
        () => getPaginationItems(currentPage, totalPages),
        [currentPage, totalPages]
    );

    // Deleting a log ==========================
    const deleteALog = async (id) => {
        try {
            const response = await fetch(`${host}/activity/delete/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": localStorage.getItem('token')
                }
            })
            const json = await response.json()
            if (response.ok) {
                const newActivityData = logData.filter(log => log._id !== id)

                setLogData(newActivityData)
            } else {
                console.error("Failed to delete the log:", json);
            }

        } catch (error) {
            console.error("Error deleting log:", error)
        }
    }

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <Sidedash />
                    <div className="col-md-10 pt-3">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header text-center">Activity Log</div>
                                    <div className='card-body'>
                                        <div className='table-responsive'>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Date</th>
                                                        <th scope="col">Time</th>
                                                        <th scope="col">User</th>
                                                        <th scope="col">Operation</th>
                                                        <th scope="col">Where</th>
                                                        <th scope="col">Changes</th>
                                                        <th scope="col">Delete</th>
                                                    </tr>
                                                </thead>
                                                {logData && logData.length > 0 ? (
                                                    <tbody>
                                                        {logData.map((log, index) => (
                                                            <tr key={log._id}>
                                                                <th scope="row">{(currentPage - 1) * limit + index + 1}</th>
                                                                <td>{formatDate(log.operationDate)}</td>
                                                                <td>{convertToIST(log.operationDate)}</td>
                                                                <td>{log.operatedBy}</td>
                                                                <td>
                                                                    <p>
                                                                        {log.operationType === 'PATCH' ? "UPDATED" : (log.operationType === 'POST'? 'NEW':log.operationType)}
                                                                    </p>
                                                                </td>
                                                                <td>{log.collectionName}</td>
                                                                <td>
                                                                    <ul>
                                                                        {log.changes && log.changes.map((change, idx) => (
                                                                            <li key={idx}>
                                                                                {/* Call humanReadableAuditLog here */}
                                                                                {humanReadableAuditLog(change, log.collectionName, log.affactedDoc, log.operationType)}
                                                                                {log.operationType  === "DELETE" && log.collectionName === 'student' ? `Student ${log.affactedDoc} has been deleted.` : ""}
                                                                                {log.operationType  === "DELETE" && log.collectionName === 'bookings' ? `Booking receipt number #${log.affactedDoc} has been deleted.` : ""}
                                                                                {log.operationType === "POST" && log.collectionName === 'bookings' ? `New Booking entry with receipt number #${log.affactedDoc} created.`: ""}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </td>
                                                                <td>
                                                                    <span className='px-1' title='Unassign' role="button" type="button" data-bs-dismiss="modal" onClick={() => { deleteALog(log._id) }}>
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16">
                                                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                        </svg>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                ) : (
                                                    // Display a message if logData is empty or not an array
                                                    <p>No activity log data found.</p>
                                                )}
                                            </table>
                                            {/* Pagination controls */}
                                            {totalPages > 0 && (
                                            <nav aria-label="Activity log pages" className="mt-3">
                                                <ul className="pagination flex-wrap">
                                                    <li className={`page-item${currentPage <= 1 ? ' disabled' : ''}`}>
                                                        <button
                                                            type="button"
                                                            className="page-link"
                                                            disabled={currentPage <= 1}
                                                            onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                                                        >
                                                            Previous
                                                        </button>
                                                    </li>
                                                    {paginationItems.map((item, idx) =>
                                                        item === 'ellipsis' ? (
                                                            <li key={`ellipsis-${idx}`} className="page-item disabled">
                                                                <span className="page-link" aria-hidden="true">…</span>
                                                            </li>
                                                        ) : (
                                                            <li
                                                                key={item}
                                                                className={`page-item${item === currentPage ? ' active' : ''}`}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="page-link"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        setCurrentPage(item);
                                                                    }}
                                                                >
                                                                    {item}
                                                                </button>
                                                            </li>
                                                        )
                                                    )}
                                                    <li className={`page-item${currentPage >= totalPages ? ' disabled' : ''}`}>
                                                        <button
                                                            type="button"
                                                            className="page-link"
                                                            disabled={currentPage >= totalPages}
                                                            onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                                                        >
                                                            Next
                                                        </button>
                                                    </li>
                                                </ul>
                                            </nav>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ActivityLog